module.exports = __webpack_public_path__ + "static/img/0013.48937e09.png";